// node_modules
import { GeneralConstants } from "Constants";
import { FC } from "react";
// Types
import { TChatMessage } from "Types";
// Components
import { ChatBubble } from "./ChatBubble";
// Styles
import styles from "./chatContainer.module.scss";

type TChatContainerProps = {
    onSendChatMessage?: (message: string, messageIndex: number) => void,
    sendChatMessagePlaceholder?: string,
    messages: TChatMessage[],
    isTyping?: boolean
}

export const ChatContainer: FC<TChatContainerProps> = ({onSendChatMessage, sendChatMessagePlaceholder, messages, isTyping}: TChatContainerProps) => {
    
    const isTypingChatMessage: TChatMessage = {
        content: <div className={`${styles.dotPulse}`}></div>,
        isResponse: true,
        isEditable: false,
        username: GeneralConstants.IGORAI_USERNAME
    };
    
    return (
        <div className={[styles.questionAnswerContainer, styles.scrollbarCustomThin].join(" ")}>
            {messages.map((message: TChatMessage, index: number) => (
                <ChatBubble key={index} messageIndex={index} message={message} editableChatboxPlaceholder={sendChatMessagePlaceholder} 
                    onSendChatMessage={onSendChatMessage} messagesCount={messages.length} />
            ))}
            {isTyping ?
                <ChatBubble message={isTypingChatMessage} messageIndex={-1} messagesCount={messages.length} />
                : null }
        </div>
    );
};